import { useState } from "react";

import StarBorderIcon from "@mui/icons-material/StarBorder";
import { Chip, Tooltip, Typography } from "@mui/material";

import { ApiRoutesItem, ApiRoutesItemPoints } from "@/api/routes";
import { ListViewType } from "@/constants";
import { CabinColorsMap, CabinMap } from "@/constants/config";
import usePlatform from "@/hooks/usePlatform";

const CabinColorItem = (props: {
  data: ApiRoutesItem;
  type: keyof ApiRoutesItemPoints;
  onClick: () => void;
  mode?: number;
}) => {
  const { data, type, mode = ListViewType.List } = props;
  const { isPc } = usePlatform();

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const tax =
    data.points.tax && data.points.tax[type]
      ? ` + $${data.points.tax[type].toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        })}  `
      : "";
  // const seats = ""
  const seats =
    data.points.ss && data.points.ss[type]
      ? `${data.points.tax && data.points.tax[type] > 0 ? " · " : ""}${data.points.ss[type]}${
          isPc ? "+ seats" : ""
        }`
      : "";
  const seats_number = data.points.ss && data.points.ss[type] ? `${data.points.tax && data.points.tax[type] > 0 ? " · " : ""}${data.points.ss[type]}` : "";
  const cabin_type = CabinMap[type] == "Premium" ? "Premium Economy" : CabinMap[type];

  return (
    <Tooltip
      open={isPc && open && !!data.points[type]}
      title={
        <div>
          <Typography className="inline" fontSize={14}>
            <div>{cabin_type}</div> 
            <div>
              {`${data.points[type]?.toLocaleString()} pts`}
              {tax}
            </div>
            <div>
              {data.points_ns[type] && data.points_ns[type] == data.points[type]
                ? "Nonstop"
                : "Has Stop(s)"}
              {type !== "ss" &&
              data.points.ss &&
              data.points.ss[type] &&
              data.points.ss &&
              data.points.ss[type] > 0
                ? " · " + data.points.ss[type] + "+ seats"
                : ""}
            </div>
            {data.points.c_a && (
              <div>{data.points.c_a[type] && data.points.c_a[type].join(", ")}</div>
            )}
          </Typography>
        </div>
      }
      placement="top"
      disableHoverListener
      disableFocusListener
      disableTouchListener
      onClose={handleClose}
    >
      <Chip
        className="w-[100%]"
        icon={
          data.points_ns[type] && data.points_ns[type] == data.points[type] ? (
            <StarBorderIcon fontSize="small" />
          ) : undefined
        }
        label={
          <div className="leading-tight">
            <div className="text-center">
              {data.points[type] ? `${data.points[type].toLocaleString()} pts` : "Not Available"}
            </div>
            <div className="text-center pr-[5px]">
              {tax}
              {mode === ListViewType.List ? seats || "" : seats_number || ""}
            </div>
          </div>
        }
        disabled={!data.points[type]}
        sx={{
          borderRadius: 2,
          backgroundColor: CabinColorsMap[type],
          fontWeight: 600,
          color: "white",
          ".MuiChip-icon": {
            color: "white",
          },
          height: "42px",
          "& .MuiChip-label": {
            display: "block",
            whiteSpace: "normal",
          },
        }}
        onClick={props.onClick}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      />
    </Tooltip>
  );
};

export default CabinColorItem;
